import { IFetchResult } from 'core/classes/helpers/store/Interfaces'
import {
  ICluster,
  IHPOrg,
  IMarket,
  IRegion,
} from 'onboarding/classes/models/partnerTerritoryModels'
import settings from 'src/config/settings'

export const PartnerTerritoryApi = {
  fetchRegions: (dataRegions: IRegion[]): IFetchResult<IRegion> => {
    return {
      items: dataRegions,
      total: dataRegions.length,
    }
  },
  fetchMarkets: (dataMarkets: IMarket[]): IFetchResult<IMarket> => {
    return {
      items: dataMarkets,
      total: dataMarkets.length,
    }
  },
  fetchHPOrgs: (dataHPOrgs: IHPOrg[]): IFetchResult<IHPOrg> => {
    return {
      items: dataHPOrgs,
      total: dataHPOrgs.length,
    }
  },
  fetchClusters: (dataClusters: ICluster[]): IFetchResult<ICluster> => {
    return {
      items: dataClusters,
      total: dataClusters.length,
    }
  },
  fetchRegionByMarket: (
    market: string,
    dataMarkets: IMarket[],
    dataRegions: IRegion[]
  ): IFetchResult<IRegion> => {
    const regionM = dataMarkets.filter((i: IMarket) => i.market === market)
    const regionStr = regionM && regionM[0] ? regionM[0].region : ''
    const data = dataRegions.filter((i: IRegion) => i.region === regionStr)
    return {
      items: data,
      total: data.length,
    }
  },
  getRegion(market: string, dataMarkets: IMarket[], dataRegions: IRegion[]): IRegion {
    if (!settings.region) {
      return {
        id: -1,
        region: 'EMEA',
      }
    }
    const row = this.fetchRegionByMarket(market, dataMarkets, dataRegions)
    return (
      (row && row.items[0]) || {
        id: -1,
        region: 'EMEA',
      }
    )
  },
}
